import { AutomatedBreakDataInTimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { AutomatedBreakType } from '@sdk/settings/types';
import { AutomatedBreaksSettingsUI } from '@sdk/automatedBreaks/types/AutomatedBreaksSettingsUI';

const getAutomatedBreaksSettingsForEntry = (
  automatedBreaks: AutomatedBreaksSettingsUI
): AutomatedBreakDataInTimesheetEntry => ({
  automatedBreakSettingMealThreshold: automatedBreaks[AutomatedBreakType.meal].breakThreshold,
  automatedBreakSettingRestThreshold: automatedBreaks[AutomatedBreakType.rest].breakThreshold,
  automatedBreakSettingMealIsEnabled: automatedBreaks[AutomatedBreakType.meal].isEnabled,
  automatedBreakSettingRestIsEnabled: automatedBreaks[AutomatedBreakType.rest].isEnabled,
  automatedBreakSettingMealDuration: automatedBreaks[AutomatedBreakType.meal].breakDuration,
  automatedBreakSettingRestDuration: automatedBreaks[AutomatedBreakType.rest].breakDuration,
  automatedBreakSettingMealIsPremiumPay: automatedBreaks[AutomatedBreakType.meal].isPremiumPay,
  automatedBreakSettingRestIsPremiumPay: automatedBreaks[AutomatedBreakType.rest].isPremiumPay,
});

export default getAutomatedBreaksSettingsForEntry;
